import React from "react"
import styled from "styled-components"
import Banner from "./Banner"
// import BaseInfo from "./BaseInfo"

const Container = styled.div``,
	Responsive = styled.div``

export default function AboutMe() {
	return (
		<Container>
			<Banner />
			{/* <Responsive className="container">
				<BaseInfo />
			</Responsive> */}
		</Container>
	)
}
